import { createFileRoute } from '@tanstack/react-router';

type Search = {
  utm_source?: string;
  mailer?: string;
  flow_type?: string;
  email?: string;
  v?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/user-invite_/$nonceToken_/location_/$locationId')({
  validateSearch: (search: Search) => search,
});
